/**
 * removes the line breaks with a space
 */
export const removeAllLineBreaks = (str) => {
  return str.replace(/(?:\r\n|\r|\n)/g, ' ');
};
/**
 * highlight a part of string
 */
export const highlightString = (str, find) => {
  // console.log('stringggggg', str);
  // console.log('find *************', find);
  if (!str) {
    return null;
  }
  if (!find) {
    return str;
  }
  return str.replace(
    find,
    `<b style="background-color: yellow" title="highlighted">${find}</b>`
  );
};
// \require{color}{\colorbox{yellow}{$+2+h$}}

export const strikeThroughString = (str, find) => {
  if (!str) {
    return null;
  }
  if (!find) {
    return str;
  }
  return removeAllLineBreaks(str).replace(
    find,
    `<b style="text-decoration: line-through" title="striked" class="highlighted-text">${find}</b>`
  );
};
export const clearSelection = () => {
  // console.log('selection sleareddd');
  if (window.getSelection) {
    if (window.getSelection().empty) {
      window.getSelection().empty();
    } else if (window.getSelection().removeAllRanges) {
      window.getSelection().removeAllRanges();
    }
  } else if (document.selection) {
    document.selection.empty();
  }
};



// WEBPACK FOOTER //
// ./src/common/highlightText.js